import { render, staticRenderFns } from "./ProductsItem.vue?vue&type=template&id=928efb72&scoped=true&"
import script from "./ProductsItem.vue?vue&type=script&lang=js&"
export * from "./ProductsItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductsItem.vue?vue&type=style&index=0&id=928efb72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928efb72",
  null
  
)

export default component.exports